







import { Component, Vue } from "vue-property-decorator";
import FloatingInner from "@/layouts/FloatingInner.vue";

@Component({
  components: { FloatingInner }
})
export default class Logout extends Vue {
  async beforeMount() {
    // GraphQL キャッシュ削除
    // @ts-ignore
    this.$apollo.provider.defaultClient.cache.reset();
    await this.$store.dispatch("app/logout");
  }
}
